<template>
    <div>
        <NavigationReceiver currentQuestion="0"></NavigationReceiver>
        <section>
            <div class="custom-container">
                <div class="row d-flex align-items-center">
                    <div class="col-xl-5">
                        <h1 class="mb-5">Helaas, de uiterste inleverdatum is verstreken</h1>
                        <p>Het onderzoek kon tot {{ formatDate(inquiry.deadline) }} ingevuld worden.</p>
                    </div>
                    <div class="col-xl-6 ms-auto">
                        <div class="bg-secondary p-5 rounded shadow-sm">
                            <div class="row">
                                <div class="col-4">
                                    <ul class="no-bullets mb-0">
                                        <li>Uitgenodigd door</li>
                                        <li>Jouw e-mailadres</li>
                                        <li>Afdeling</li>
                                        <li>Datum uitnodiging</li>
                                        <li>Uiterste inleverdatum</li>
                                    </ul>
                                </div>
                                <div class="col-8">
                                    <ul class="no-bullets mb-0">
                                        <li><span class="bold">{{ sender.name }}</span></li>
                                        <li><span class="bold">{{ recipient.email }}</span></li>
                                        <li><span class="bold">{{ inquiry.department }}</span></li>
                                        <li><span class="bold">{{ formatDate(inquiry.sent) }}</span></li>
                                        <li><span class="bold text-danger">{{ formatDate(inquiry.deadline) }}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NavigationReceiver from "../../../defaults/Navigation-receiver";
import RecipientService from "../../../../services/RecipientService";
import {DateTime} from "luxon";

export default {
    name:       'Expired',
    components: { NavigationReceiver },
    data() {
        return {
            sender:    {
                name: null
            },
            recipient: {
                email: null
            },
            inquiry:   {
                department: null
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        RecipientService.getPrerequisites(to, from, next);
    },
    methods: {
        formatDate(date) {
            return DateTime.fromJSDate(new Date(date)).setLocale('nl').toFormat('dd LLL yyyy');
        },
        nextStep(event) {
            event.preventDefault();
            event.currentTarget.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';

            this.$router.push({ path: '/onderzoek/' + this.recipient.hash + '/stap-1' })
        }
    },
    mounted() {
        if(this.inquiry.isExpired === false) {
            this.$router.push({ name: 'inquiry-start' });
        }
    }
}
</script>
